import React from "react";
import {DASHBOARD_LOCALES, DASHBOARD_LOCALE_STRINGS} from "./constants";
import {getLocalStorageValue, setLocalStorageValue} from "../utils/local_storage";

const initialDashboardState = {
    langCode: DASHBOARD_LOCALES.en,
    strings: DASHBOARD_LOCALE_STRINGS[DASHBOARD_LOCALES.en]
};
const DashboardLocaleContext = React.createContext(undefined);

const reducer = (state, action) => {
    switch (action.type) {
        case "CHANGE_DASHBOARD_LOCALE": {
            setLocalStorageValue("dashboard_lang_code", action.payload.langCode)
            return {
                langCode: action.payload.langCode,
                strings: DASHBOARD_LOCALE_STRINGS[action.payload.langCode]
            }
        }
        default:
            return state;
    }
}

export const DashboardLocaleProvider = ({ children }) => {
    const langCode = getLocalStorageValue("dashboard_lang_code", DASHBOARD_LOCALES.en)
    const initDashboardState = {
        langCode: langCode,
        strings: DASHBOARD_LOCALE_STRINGS[langCode]
    }
    const [state, dispatch] = React.useReducer(reducer, initDashboardState);
    return (
        <DashboardLocaleContext.Provider
            value={{state, dispatch}}
        >
            {children}
        </DashboardLocaleContext.Provider>
    )
}

export const useDashboardLocale = () => {
    const context = React.useContext(DashboardLocaleContext);
    const { state, dispatch } = context;
    const changeLocale = (langCode) => {
        dispatch({
            type: "CHANGE_DASHBOARD_LOCALE",
            payload: {
                langCode: langCode,
            }
        });
    };
    return {
        strings: state.strings,
        langCode: state.langCode,
        changeLocale,
    };
};
